/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Box } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

import type { ProductData } from "@spwn/types/firebase/firestore";
import type { FC } from "react";

export const ProductImageWithInfo: FC<{
  goodsItem: ProductData;
  onClick: () => void;
}> = ({ goodsItem, onClick }) => {
  return (
    <Box
      position={"relative"}
      width={"150px"}
      height={"150px"}
      style={{
        aspectRatio: "1 / 1",
        objectFit: "cover",
      }}
    >
      <img
        src={goodsItem.thumbnail}
        alt={goodsItem.name}
        style={{
          width: "100%",
          height: "auto",
        }}
      />
      <Box
        position={"absolute"}
        top={"4px"}
        left={"4px"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        width={"24px"}
        height={"24px"}
        color={"#bbbbbb"}
        bgcolor={"#fff"}
        borderRadius={"50%"}
        style={{
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <InfoIcon />
      </Box>
    </Box>
  );
};
